module.exports = __webpack_public_path__ + "static/img/1-2.7c5e6898.png";